<template>
    <div class="d-flex align-items-center">
        <animal-avatar :thumbnail-absolute-path="value.thumbnail" :size="48" :species="value.species" />
        <div class="d-flex flex-column">
            <div>
                <slot name="value">
                    <div class="d-flex flex-column">
                        <div class="flex-nowrap">
                            <b-link :to="{ name: 'animalDetail', params: { id: value.id } }"><strong>№{{ value.reg_number }}</strong></b-link>
                            <b-icon v-if="value.reviewed" icon="check-circle-fill" variant="success" class="ml-1" v-b-tooltip="getReviewTooltip()"/>
                            <b-icon v-if="!value.reviewed && value['review_date']" icon="question-circle-fill" variant="warning" class="ml-1" v-b-tooltip="getStaleReviewTooltip()"/>
                        </div>
                        <b-link :to="{ name: 'animalDetail', params: { id: value.id } }"><span class="text-nowrap">{{ value.shelter_reg_number }}</span></b-link>
                    </div>
                </slot>
            </div>
            <div>
                <slot name="secondary">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
    import dog from '../../assets/img/dog.png'
    import cat from '../../assets/img/cat.png'
    import AnimalAvatar from "@/pages/AppPages/Animals/AnimalAvatar.vue";

    export default {
        name: "AnimalAvatarCell",
        components: {AnimalAvatar},
        props: {
            value: {}
        },
        data() {
            return {
                dog,
                cat
            }
        },
        methods: {
            getReviewTooltip() {
                return 'Проверено ' + this.value['review_date']
            },
            getStaleReviewTooltip() {
                return `После проверки ${this.value['review_date']} были внесены изменения`;
            }
        }
    }
</script>

<style scoped>

</style>